<template>
  <div>
     
    <v-row
      class="pa-4 pr-1">
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat
          min-height="calc(100vh - 380px)">

          <v-card-text
            v-if="Object.keys(detail).length < 1" 
            class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <div class="mb-2 title">
                Mohon Tunggu...
              </div>
              <v-progress-circular
                indeterminate
              ></v-progress-circular>
            </div>
          </v-card-text>

          <v-card-text v-if="Object.keys(detail).length > 0">
            <div>
              <div>
                Status Approval
              </div>
              <div class="fs-16 label-input">
                {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Diterima' : 'Ditolak'}}
              </div>
            </div>
            <div class="" v-if="detail.status === 'rejected'">
              <div>
                Alasan
              </div>
              <div class="fs-16 label-input">
                {{ detail.rejected_reason }}
              </div>
            </div>
            <div v-if="detail.status === 'approved'">
              <div>
                Kode Aktivasi
              </div>
              <div class="fs-16 label-input">
                {{ detail.activation_code === '' ? '-' : detail.activation_code }}
              </div>
            </div>
            <!-- <div class="" v-if="(detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Supervisor,General Manager' || detail.approved_by === 'Sales Manager,General Manager') && detail.approved_reason !== ''">
              <div>
                Alasan Approve
              </div>
              <div class="fs-16 label-input">
                {{ detail.approved_reason }}
              </div>
            </div> -->
            <v-row v-if="detail.status !== 'rejected'">

              <v-col cols="12" md="4">
                <v-card
                  class="pa-0"
                  height="100%"
                  flat
                  style="border-radius: 15px; border: 1px solid #E7E7E7;">
                  <v-toolbar
                    color="#F06292"
                    dark>
                    <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                      Supervisor
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <div v-if="detail.approved_supervisor_id === '0' && (user.category_user_title === 'General Manager' && detail.approved_gm_id === '0')">
                      <v-checkbox
                        v-model="approve_name"
                        v-on-change="toChange()"
                        value="Supervisor"
                        color="white"
                        style="color: white !important"
                        hide-details
                      ></v-checkbox>
                    </div>

                  </v-toolbar>

                  <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                    Supervisor
                  </v-card-text> -->

                  <v-card-text class="body-2 font-weight-light text-first">
                    <!-- <p class="mb-2">
                      <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                      <span v-if="item.start === item.end">
                        Tanggal <b>{{ item.date | date }}</b>
                      </span>
                    </p> -->

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-account</v-icon>
                      <span>
                        <b>{{ detail.approved_supervisor_id === '0' ? '-' : detail.approved_supervisor_name }}</b>
                      </span>
                    </p>

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                      <span>
                        <b>
                          <span v-if="detail.approved_supervisor_id === '0'">
                            -
                          </span>
                          <span v-if="detail.approved_supervisor_id !== '0'">
                            {{ (detail.approved_supervisor_datetime) | datetime }}
                          </span>
                        </b>
                        <!-- <b>{{ detail.approved_supervisor_id === '0' ? '-' : (detail.approved_supervisor_datetime | datetime) }}</b> -->
                        <!-- <b v-if="detail.customer_approval.Supervisor.length > 0">{{  detail.customer_approval.Supervisor[0].customer_approval_datetime | datetime  }}</b> -->
                        <!-- <b v-else>
                          <span v-if="detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Supervisor,General Manager'">
                            {{  detail.customer_approval.General_Manager[0].customer_approval_datetime | datetime  }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </b> -->
                      </span>
                    </p>

                    <div v-if="detail.approved_supervisor_reason !== ''"  class="mt-2">

                      <div>
                        Alasan Approve
  
                      </div>
                      <div class="fs-16 label-input">
                        {{ detail.approved_supervisor_reason }}
                      </div>
                    </div>


                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card
                  class="pa-0"
                  height="100%"
                  flat
                  style="border-radius: 15px; border: 1px solid #E7E7E7;">
                  <v-toolbar
                    color="#42A5F5"
                    dark>
                    <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                      Sales Manager
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <div v-if="detail.approved_sales_manager_id === '0' && (user.category_user_title === 'General Manager' && detail.approved_gm_id === '0')">
                      <v-checkbox
                        v-model="approve_name"
                        v-on-change="$emit('approved', approve_name)"
                        :disabled="detail.approved_supervisor_id === '0' ? approve_name.length > 0 ? false : true : false"
                        color="white"
                        value="Sales Manager"
                        hide-details
                      ></v-checkbox>
                    </div>

                  </v-toolbar>

                  <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                    Sales Manager
                  </v-card-text> -->

                  <v-card-text class="body-2 font-weight-light text-first">
                    <!-- <p class="mb-2">
                      <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                      <span v-if="item.start === item.end">
                        Tanggal <b>{{ item.date | date }}</b>
                      </span>
                    </p> -->
                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-account</v-icon>
                      <span>
                        <b>{{ detail.approved_sales_manager_id === '0' ? '-' : detail.approved_sales_manager_name }}</b>
                      </span>
                    </p>

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                      <span>
                        <!-- <b>{{ detail.approved_sales_manager_id === '0' ? '-' :( (detail.approved_sales_manager_datetime) | datetime) }}</b> -->
                        <b>
                          <span v-if="detail.approved_sales_manager_id === '0'">
                            -
                          </span>
                          <span v-if="detail.approved_sales_manager_id !== '0'">
                            {{ (detail.approved_sales_manager_datetime) | datetime }}
                          </span>
                        </b>
                        <!-- <b v-if="detail.customer_approval.Supervisor.length > 0">{{  detail.customer_approval.Supervisor[0].customer_approval_datetime | datetime  }}</b> -->
                        <!-- <b v-else>
                          <span v-if="detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Supervisor,General Manager'">
                            {{  detail.customer_approval.General_Manager[0].customer_approval_datetime | datetime  }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </b> -->
                      </span>
                    </p>

                    <div v-if="detail.approved_sales_manager_reason !== ''"  class="mt-2">

                      <div>
                        Alasan Approve
  
                      </div>
                      <div class="fs-16 label-input">
                        {{ detail.approved_sales_manager_reason }}
                      </div>
                    </div>

                    <!-- <p class="mb-2">
                      <v-icon small class="mr-2">mdi-account</v-icon>
                      <span>
                        <b>{{ detail.customer_approval.Sales_Manager.length < 1 ? detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Sales Manager,General Manager' ? detail.customer_approval.General_Manager[0].user_name : '-' : detail.customer_approval.Sales_Manager[0].user_name }}</b>
                      </span>
                    </p>

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                      <span>
                        <b v-if="detail.customer_approval.Sales_Manager.length > 0">{{  detail.customer_approval.Sales_Manager[0].customer_approval_datetime | datetime  }}</b>
                        <b v-else>
                          <span v-if="detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Sales Manager,General Manager'">
                            {{  detail.customer_approval.General_Manager[0].customer_approval_datetime | datetime  }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </b>
                      </span>
                    </p>

                    <div v-if="detail.approved_reason.name === 'Sales Manager' || detail.approved_reason.name === 'all'" class="mt-2">

                      <div>
                        Alasan Approve
  
                      </div>
                      <div class="fs-16 label-input">
                        {{ detail.approved_reason.reason }}
                      </div>
                    </div> -->



                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card
                  class="pa-0"
                  height="100%"
                  flat
                  style="border-radius: 15px; border: 1px solid #E7E7E7;">
                  <v-toolbar
                    color="#66BB6A"
                    dark>
                    <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                      General Manager
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    

                  </v-toolbar>

                  <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                    General Manager
                  </v-card-text> -->

                  <v-card-text class="body-2 font-weight-light text-first">
                    <!-- <p class="mb-2">
                      <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                      <span v-if="item.start === item.end">
                        Tanggal <b>{{ item.date | date }}</b>
                      </span>
                    </p> -->

                    <!-- <p class="mb-2">
                      <v-icon small class="mr-2">mdi-account</v-icon>
                      <span>
                        <b>{{ detail.customer_approval.General_Manager.length < 1 ? '-' : detail.customer_approval.General_Manager[0].user_name }}</b>
                      </span>
                    </p>

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                      <span>
                        <b v-if="detail.customer_approval.General_Manager.length > 0">{{  detail.customer_approval.General_Manager[0].customer_approval_datetime | datetime  }}</b>
                        <b v-else>-</b>
                      </span>
                    </p> -->

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-account</v-icon>
                      <span>
                        <b>{{ detail.approved_gm_id === '0' ? '-' : detail.approved_gm_name }}</b>
                      </span>
                    </p>

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                      <span>
                        <b>
                          <span v-if="detail.approved_gm_id === '0'">
                            -
                          </span>
                          <span v-if="detail.approved_gm_id !== '0'">
                            {{ (detail.approved_gm_datetime) | datetime }}
                          </span>
                        </b>
                        <!-- <b v-if="detail.customer_approval.Supervisor.length > 0">{{  detail.customer_approval.Supervisor[0].customer_approval_datetime | datetime  }}</b> -->
                        <!-- <b v-else>
                          <span v-if="detail.approved_by === 'Supervisor,Sales Manager,General Manager' || detail.approved_by === 'Supervisor,General Manager'">
                            {{  detail.customer_approval.General_Manager[0].customer_approval_datetime | datetime  }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </b> -->
                      </span>
                    </p>

                    <!-- <div v-if="detail.approved_sales_manager_reason !== ''"  class="mt-2">

                      <div>
                        Alasan Approve
  
                      </div>
                      <div class="fs-16 label-input">
                        {{ detail.approved_sales_manager_reason }}
                      </div>
                    </div> -->


                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="detail.status === 'rejected'">
              <v-col cols="12" md="4">
                <v-card
                  class="pa-0"
                  height="100%"
                  flat
                  style="border-radius: 15px; border: 1px solid #E7E7E7;">
                  <v-toolbar
                    :color="set_color"
                    dark>
                    <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                      Staff yg Menolak
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <!-- <div v-if="detail.customer_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.customer_approval.Supervisor.length < 1">
                      <v-checkbox
                        v-model="approve_name"
                        v-on-change="$emit('approved', approve_name)"
                        value="Supervisor"
                        color="white"
                        style="color: white !important"
                        hide-details
                      ></v-checkbox>
                    </div> -->

                  </v-toolbar>

                  <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                    Supervisor
                  </v-card-text> -->

                  <v-card-text class="body-2 font-weight-light text-first">
                    <!-- <p class="mb-2">
                      <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                      <span v-if="item.start === item.end">
                        Tanggal <b>{{ item.date | date }}</b>
                      </span>
                    </p> -->

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-account</v-icon>
                      <span>
                        <b>{{ detail.user_rejected_name }}</b>
                      </span>
                    </p>

                    <p class="mb-2">
                      <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                      <span>
                        <b>{{ detail.rejected_date | date  }}</b>
                      </span>
                    </p>


                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <div v-if="message.error.length > 0"
              class="text-center my-4 d-flex align-center">
              <div
                class="error--text">
                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detail: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,

          approve_name: [],

        
  
          process: {
            form: false,
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {

      },
      watch: {
        
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
      },
      methods: {
        toChange () {
          if(this.approve_name.length > 0 && this.approve_name[0] === 'Sales Manager') {
            this.approve_name = [] 
          }
          this.$emit('approved', this.approve_name)
        },
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
      }
    }
  </script>